import Swiper, {Navigation} from 'swiper';


const carousel = (container, type = 'mobile') => {
    let slider = undefined;

    if ($(container).length > 0) {
        function initMobileSlider() {
            const width = $(window).width();
            if (width <= 1024) {
                if (typeof slider === typeof undefined) {
                    if (container === '.js-landing-benefits-slider') {
                        slider = new Swiper(container, {
                            modules: [Navigation],
                            slidesPerView: 1.25,
                            spaceBetween: 15,
                            centeredSlides: true,
                            navigation: {
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev",
                            },
                            breakpoints: {
                                1024: {
                                    slidesPerView: 2.2,
                                },
                                992: {
                                    slidesPerView: 1.75
                                },
                                576: {
                                    slidesPerView: 1.5,
                                    spaceBetween: 20,
                                },
                            },
                        });
                    } else {
                        slider = new Swiper(container, {
                            modules: [Navigation],
                            slidesPerView: 1,
                            spaceBetween: 20,
                            navigation: {
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev",
                            },
                            breakpoints: {
                                1024: {
                                    slidesPerView: 2
                                },
                                992: {
                                    slidesPerView: 1.75
                                },
                                576: {
                                    slidesPerView: 1.5
                                },
                            },
                        });
                    }
                }
            } else {
                if (typeof slider !== typeof undefined) {
                    slider.destroy(true, true);
                    slider = undefined;
                }
            }
        }

        function initDesktopSlider() {
            slider = new Swiper(container, {
                modules: [Navigation],
                slidesPerView: 1,
                spaceBetween: 20,
                grabCursor: true,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    1460: {
                        slidesPerView: 3.5,
                        spaceBetween: 80,
                    },
                    1024: {
                        slidesPerView: 2.5,
                        spaceBetween: 60,
                    },
                    992: {
                        slidesPerView: 2,
                        spaceBetween: 40,
                    },
                    576: {
                        slidesPerView: 1.5
                    },
                },
            });
        }

        if (type === 'mobile') {
            initMobileSlider();
            $(window).on('resize', function () {
                initMobileSlider();
            })
        } else {
            initDesktopSlider();
        }
    }
}
export default carousel;